import { SEARCH_QUERY_TYPE } from '~/utils/search/search.constants'

export function findFieldByKey (filedKey, type = SEARCH_QUERY_TYPE) {
  for (const [key, value] of Object.entries(type)) {
    if (key === filedKey) {
      return { ...value, key }
    }
    if (value?.routerKey === filedKey) {
      return { ...value, key }
    }
    if (value?.responseKey === filedKey) {
      return { ...value, key }
    }
    if (value?.requestKey === filedKey) {
      return { ...value, key }
    }
  }
  return null
}

export function convertToObject (data) {
  const parsedData = {}

  Object.keys(data).forEach((key) => {
    const value = data[key]
    const typeConfig = findFieldByKey(key)

    if (!typeConfig) {
      parsedData[key] = value
      return
    }

    switch (typeConfig.type) {
      case 'list':
        if (typeof value === 'string') {
          parsedData[key] = value.split(',')
        } else {
          parsedData[key] = Array.isArray(value) ? value : value ? [value] : []
        }
        break

      case 'minmax':
        if (typeof value === 'string') {
          const range = value.split(',')
          parsedData[key] = { min: range[0] || 0, max: range[1] || 0 }
        } else {
          parsedData[key] = {
            min: value?.min || 0,
            max: value?.max || 0
          }
        }
        break

      case 'minmaxRanges':
        if (typeof value === 'string') {
          const range = value.split(',')
          parsedData[key] = { min: range[0] || 0, max: range[1] || 0 }
        } else {
          parsedData[key] = {
            start: {
              min: value?.start?.min || 0,
              max: value?.start?.max || 0
            },
            end: {
              min: value?.end?.min || 0,
              max: value?.end?.max || 0
            }
          }
        }
        break

      case 'boolean':
        parsedData[key] = value === 'true' || value === true
        break

      case 'string':
        parsedData[key] = typeof value === 'string' ? value : value?.toString() || null
        break

      case 'integer':
        parsedData[key] = parseInt(value, 10)
        break

      default:
        parsedData[key] = value
    }

    switch (typeConfig.subType) {
      case 'integer':
        if (parsedData[key]) {
          if (Array.isArray(parsedData[key])) {
            parsedData[key] = parsedData[key].map(i => parseInt(i, 10))
          }
          if (typeof parsedData[key] === 'string') {
            parsedData[key] = parseInt(parsedData[key], 10)
          }
        }
        break
      default:
        break
    }
  })
  return parsedData
}

export function findBoatTypeBySlug (boatTypes, searchSlug) {
  if (!searchSlug || !boatTypes) {
    return null
  }

  return boatTypes.find((boatType) => {
    return getBoatTypeSlugs(boatType).includes(searchSlug)
  })
}

export function getBoatTypeSlugs (boatType) {
  return [
    boatType?.values[0]?.search_slug,
    boatType?.values[0]?.slug,
    boatType?.values[0]?.db_slug,
    boatType?.values[1]?.search_slug,
    boatType?.values[1]?.slug,
    boatType?.values[1]?.db_slug
  ].filter(Boolean)
}

export function findBoatTypeById (boatTypes, id) {
  if (!id || !boatTypes) {
    return null
  }

  return boatTypes.find((boatType) => {
    return parseInt(boatType.id, 10) === parseInt(id, 10)
  })
}

export function findCharterTypeBySlug (charterTypes, searchSlug) {
  if (!searchSlug || !charterTypes) {
    return null
  }

  return charterTypes.find((charterType) => {
    const slugsToCheck = [
      charterType.transTitle
    ]

    return slugsToCheck.includes(searchSlug)
  })
}

export function findCharterTypeById (charterTypes, id) {
  if (!id || !charterTypes) {
    return null
  }

  return charterTypes.find((charterType) => {
    return parseInt(charterType.id, 10) === parseInt(id, 10)
  })
}

export function mergeUniqueById (first, second) {
  const toArray = (src) => {
    if (!src) {
      return []
    }
    if (Array.isArray(src)) {
      return src
    }

    if (src.boatType) {
      return [src.boatType]
    }
    if (src.boat_type_id) {
      return src.boat_type_id
    }

    return [src]
  }

  const firstArray = toArray(first)
  const secondArray = toArray(second)

  const uniqueMap = new Map()

  firstArray.forEach((item) => {
    if (item?.id) {
      uniqueMap.set(item.id, item)
    }
  })

  secondArray.forEach((item) => {
    if (item?.id) {
      uniqueMap.set(item.id, item)
    }
  })

  return Array.from(uniqueMap.values())
}
